export const DesignationEndpoints = {
    createDesignation: {
        method: "post",
        url: "/designations",
    },
    getAllDesignations: {
        method: "get",
        url: "/designations",
    },
    getDesignation: (id) => ({
        method: "get",
        url: `/designations/${id}`,
    }),
    updateDesignation: (id) => ({
        method: "put",
        url: `/designations/${id}`,
    }),
    deleteDesignation: (id) => ({
        method: "delete",
        url: `/designations/${id}`,
    }),
};
